module.exports = __webpack_public_path__ + "static/media/splashfiller1.2c273915.gif";